import { css } from '@emotion/react';
import { darkThemeStyle, theme } from '../theme';
import { tokens } from '../tokens';
// Mapping between input's sizes and design tokens
export const sizeMap = {
    large: {
        sizing: tokens.sizing.large,
        spacing: tokens.spacingNew.medium,
        spacingWithEnhancer: '40px',
    },
    medium: {
        sizing: tokens.sizing.medium,
        spacing: '12px',
        spacingWithEnhancer: '36px',
    },
    small: {
        sizing: tokens.sizing.small,
        spacing: '12px',
        spacingWithEnhancer: tokens.spacingNew.xlarge,
    },
};
const inputWrapperStaticStyle = css({
    '&::after': {
        borderRadius: '6px',
        content: '""',
        display: 'block',
        inset: 0,
        margin: '-2px',
        pointerEvents: 'none',
        position: 'absolute',
        transition: 'box-shadow 125ms ease-out',
        zIndex: tokens.zIndex.default,
    },
    position: 'relative',
    width: '100%',
});
export function inputWrapperStyle({ disabled, inverted, isFocused, size, }) {
    return [
        ...(inverted ? [darkThemeStyle] : []),
        inputWrapperStaticStyle,
        css(Object.assign({ height: sizeMap[size].sizing, opacity: disabled ? tokens.opacity.medium : 1 }, (isFocused && {
            '&::after': {
                boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
            },
        }))),
    ];
}
const inputStaticStyle = css({
    '&::-ms-clear, &::-ms-reveal': {
        display: 'none',
        height: 0,
        width: 0,
    },
    '&::-webkit-search-decoration, &::-webkit-search-cancel-button, &::-webkit-search-results-button, &::-webkit-search-results-decoration': {
        display: 'none',
    },
    '&::placeholder': {
        color: theme.text.subtle,
        opacity: 1,
    },
    '&:-webkit-autofill': {
        boxShadow: `0 0 0 ${tokens.sizing.medium} white inset`,
    },
    '&:disabled': {
        cursor: 'default',
    },
    appearance: 'none',
    backgroundColor: theme.background.contrast,
    border: `${tokens.borderWidth.thin} solid ${theme.border.strong}`,
    borderRadius: tokens.borderRadius.medium,
    color: theme.text.main,
    cursor: 'text',
    display: 'flex',
    fontFamily: tokens.fontFamilies.sansSerif,
    fontWeight: tokens.fontWeights.regular,
    height: '100%',
    lineHeight: tokens.lineHeights.relaxed,
    outline: 0,
    width: '100%',
});
export function inputStyle({ hasEnhancerRight, hasError, hasIconLeft, size, }) {
    return [
        inputStaticStyle,
        css(Object.assign({ fontSize: tokens.fontSizes[size], paddingLeft: hasIconLeft
                ? sizeMap[size].spacingWithEnhancer
                : sizeMap[size].spacing, paddingRight: hasEnhancerRight
                ? sizeMap[size].spacingWithEnhancer
                : sizeMap[size].spacing }, (hasError && {
            borderColor: theme.error.darker,
            boxShadow: `0 0 0 1px ${theme.error.darker}`,
        }))),
    ];
}
const enhancerSharedStaticStyle = css({
    alignItems: 'center',
    color: theme.text.main,
    display: 'flex',
    height: '100%',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    zIndex: tokens.zIndex.default,
});
export function iconLeftStyle({ size }) {
    return [
        enhancerSharedStaticStyle,
        css({
            left: sizeMap[size].spacing,
        }),
    ];
}
export function enhancerRightStyle({ size }) {
    return [
        enhancerSharedStaticStyle,
        css({
            right: sizeMap[size].spacing,
        }),
    ];
}
const enhancerStaticStyle = css({
    '&:disabled': {
        cursor: 'inherit',
    },
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: 0,
    borderRadius: tokens.borderRadius.medium,
    color: 'inherit',
    cursor: 'pointer',
    display: 'flex',
    marginRight: '-2px',
    outline: 0,
    padding: '2px',
    pointerEvents: 'auto',
});
export function enhancerStyle({ isFocusVisible }) {
    return [
        enhancerStaticStyle,
        css(Object.assign({}, (isFocusVisible && {
            boxShadow: `0 0 0 2px ${theme.border.focusOutline}`,
        }))),
    ];
}
